import styled from "@emotion/styled";
import { IconButton, Tooltip } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { useSupportDialog } from "@shared/hooks/useSupportDialog";
import { SupportConfirmDialog } from "@shared/components/SupportConfirmDialog";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  position: fixed;
  z-index: 200;
  right: 0.5rem;
  bottom: 0.5rem;
`;

export const SubscriptionSupportButton = () => {
  const { isOpen, open, close } = useSupportDialog();

  return (
    <>
      <ButtonContainer>
        <Tooltip title="Need help?" placement="left">
          <IconButton onClick={open}>
            <HelpIcon />
          </IconButton>
        </Tooltip>
      </ButtonContainer>

      <SupportConfirmDialog open={isOpen} onClose={close} />
    </>
  );
};
